import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import IconButton from 'components/common/IconButton';
import { useUser } from 'context/UserContext';
import { titler } from 'helpers/titler';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Card, Nav, ProgressBar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Guide = ({ start = false }) => {
  titler('Guida del CapoClasse');
  const navigate = useNavigate();
  const user = useUser();
  const [step, setStep] = useState(1);
  const navItems = [
    {
      icon: 'user-plus',
      label: 'Step 1'
    },
    {
      icon: 'comments',
      label: 'Step 2'
    },
    {
      icon: 'users',
      label: 'Step 3'
    },
    {
      icon: 'check',
      label: 'Step 4'
    }
  ];

  return (
    <>
      {start ? (
        <Card className="mb-3">
          <Card.Body>
            <h3 className="fw-light fs-4 mb-0 text-primary text-center">
              <strong>Hai creato la tua CLASSE!</strong>
            </h3>
            <h5 className="fw-light fs-8 mt-3 text-center">
              Sei diventato <strong>Capoclasse</strong>!✅
            </h5>
            <h5 className="fw-light fs-8 mt-3 text-center">
              Segui questa rapida guida per sapere <strong>come fare</strong>{' '}
              per <strong>iniziare a giocare!</strong>
            </h5>
          </Card.Body>
        </Card>
      ) : (
        <Card className="mb-3">
          <Card.Body>
            <h3 className="fw-light fs-6 mb-0 text-primary text-center">
              <strong>Guida del CapoClasse</strong>
            </h3>
          </Card.Body>
        </Card>
      )}
      <Card className="theme-wizard mb-5">
        <Card.Header className="bg-body-tertiary pb-2">
          <Nav className="justify-content-center">
            {navItems.map((item, index) => (
              <NavItem
                key={item.label}
                index={index + 1}
                step={step}
                setStep={setStep}
                icon={item.icon}
                label={item.label}
              />
            ))}
          </Nav>
        </Card.Header>
        <ProgressBar now={step * 25} style={{ height: 2 }} />
        <Card.Body className="fw-normal px-md-6 py-4">
          {step === 1 && (
            <>
              <h5 className="fs-9 text-primary">STEP 1</h5>
              <h2 className="mb-3">Aggiungere PROFESSORI e STUDENTI</h2>
              <h5 className="fw-light">
                La <strong>prima cosa</strong> da fare è aggiungere{' '}
                <strong>professori</strong> e <strong>studenti</strong> della
                tua classe su FantaClasse.
              </h5>
              <br />
              <h5 className="fw-light">
                Inserisci i <strong>nomi</strong> e stabilisci dei{' '}
                <strong>prezzi</strong> adeguati, ricordando che{' '}
                <strong>
                  ogni giocatore ha a disposizione 100 crediti per comprare un
                  professore e 4 studenti
                </strong>
              </h5>
              <br />
              <h5 className="fw-light">
                È possible farlo dalla pagina "Classe".
              </h5>
            </>
          )}
          {step === 2 && (
            <>
              <h5 className="fs-9 text-primary">STEP 2</h5>
              <h2 className="mb-3">Invita i TUOI COMPAGNI!</h2>
              <h5 className="fw-light">
                È <strong>semplicissimo</strong>: devono registrarsi, cliccare
                su <strong>Unisciti a una classe</strong> e inserire il{' '}
                <strong>Codice Classe</strong>
              </h5>
              <hr />
              <h5 className="text-secondary">
                Codice Classe:{' '}
                <strong
                  onClick={() => {
                    navigator.clipboard.writeText(user.classroomCode);
                  }}
                >
                  {user.classroomCode}
                </strong>
              </h5>
            </>
          )}
          {step === 3 && (
            <>
              <h5 className="fs-9 text-primary">STEP 3</h5>
              <h2 className="mb-3">Create le vostre SQUADRE!</h2>
              <h5 className="fw-light">
                Dopo che tutti i tuoi compagni sono entrati nella classe,{' '}
                <strong>create</strong> le <strong>vostre squadre</strong>!
              </h5>
              <br />
              <h5 className="fw-light">
                Ogni giocatore ha a dispozione <strong>100 crediti</strong> per
                comprare <strong>un professore</strong> e{' '}
                <strong>4 studenti</strong>, che possono essere in più squadre
                contemporaneamente.
              </h5>
              <br />
              <div
                className="alert alert-warning border-2 d-flex align-items-center"
                role="alert"
              >
                <div className="bg-warning me-3 icon-item">
                  <FontAwesomeIcon
                    icon="exclamation-circle"
                    className="text-white fs-6"
                  />
                </div>
                <p className="mb-0 flex-1">
                  Attenzione - Ti ricordiamo che, una volta creata,{' '}
                  <strong>non</strong> sarà più possibile modificare una squadra
                </p>
              </div>
            </>
          )}
          {step === 4 && (
            <>
              <h5 className="fs-9 text-primary">STEP 4</h5>
              <h2 className="mb-3">Inizia la COMPETIZIONE!</h2>
              <h5 className="fw-light">
                Dopo aver creato le squadre, è ora di{' '}
                <strong>iniziare a giocare!</strong>
              </h5>
              <br />
              <h5 className="fw-light">
                In quanto Capo Classe, devi aggiungere <strong>bonus</strong> e{' '}
                <strong>malus</strong> in base a quanto succede in aula.
              </h5>
              <h5 className="fw-light">
                Per farlo, clicca sul nome dello studente o del docente, e poi
                su <strong>BONUS/MALUS</strong>!
              </h5>
              <br />
              <h5 className="fw-light">
                Una sola regola:{' '}
                <strong>la squadra che accumula più punti vince!</strong>
              </h5>
              <br />
            </>
          )}
        </Card.Body>
        <Card.Footer className="px-md-6 bg-body-tertiary d-flex">
          <IconButton
            variant="link"
            icon={'chevron-left'}
            iconAlign="left"
            transform="down-1 shrink-4"
            className={classNames('px-0 fw-semibold', {
              'd-none': step === 1
            })}
            onClick={() => {
              setStep(step - 1);
            }}
          >
            Indietro
          </IconButton>

          <IconButton
            variant="primary"
            className={classNames('ms-auto px-5', {
              'd-none': step === 4
            })}
            type="submit"
            icon={'chevron-right'}
            iconAlign="right"
            transform="down-1 shrink-4"
            onClick={() => {
              if (step === 4) {
                navigate('/classe');
              } else {
                setStep(step + 1);
              }
            }}
          >
            Avanti
          </IconButton>

          <IconButton
            variant="primary"
            className={classNames('ms-auto', {
              'd-none': step != 4
            })}
            type="submit"
            icon={'chevron-right'}
            iconAlign="right"
            transform="down-1 shrink-4"
            onClick={() => {
              navigate('/classe');
            }}
          >
            Vai alla tua classe
          </IconButton>
        </Card.Footer>
      </Card>
    </>
  );
};

const NavItem = ({ index, step, setStep, icon, label }) => {
  return (
    <Nav.Item>
      <Nav.Link
        className={classNames('fw-semibold', {
          done: index < 4 ? step > index : step > 3,
          active: step === index
        })}
        onClick={() => {
          setStep(index);
        }}
      >
        <span className="nav-item-circle-parent">
          <span className="nav-item-circle">
            <FontAwesomeIcon icon={icon} />
          </span>
        </span>
        <span className="d-none d-md-block mt-1 fs-10">{label}</span>
      </Nav.Link>
    </Nav.Item>
  );
};

Guide.propTypes = {
  start: PropTypes.bool
};

NavItem.propTypes = {
  index: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Guide;
